import Maps from "../../components/maps";
import Navbar from "../../components/navbar/navbar";
import Client from "./clients";
import FooterCopy from "./footer_copy";
import About from "./about";
import CallToAction from "./call_to_action";
import CallToAction2 from "./call_to_action2";
import Contacto from "./contact";
import Faq from "./faq";
import Footer from "./footer";
import Header from "./header";
import Home from "./home";
import Services from "./services/services";
import WhatsAppButton from "../../components/whatsappBtn";

export default function Index() {
  return (
    <>
      <WhatsAppButton Href={"+5216311934479"}/>
      <Navbar />
      <Header/>
      <Home/>
      <Services/>
      <CallToAction/>
      <About/>
      <Faq/>
      <CallToAction2/>
      {/*<Client/>*/}
      <Contacto/>
      <Footer/>
      <FooterCopy/>
    </>
  );
}

